<template>
  <section>
    <!-- 面包屑 -->
    <!-- <breadcrumbs></breadcrumbs> -->
    <!-- 查询条件 -->
    <div class="data-container scroll-table">
      <!-- 库存盘点 -->
      <el-table :data="tableData"
                border
                style="width: 100%"
                @selection-change="tableSelectionChange">
        <el-table-column type="index" label="序号" width="50"> </el-table-column>
        <el-table-column prop="customerName" label="品牌"> </el-table-column>
        <el-table-column prop="customerName" label="原次数总数"> </el-table-column>
        <el-table-column prop="customerName" label="变更次数总数为"> </el-table-column>
        <el-table-column prop="customerName" label="当前库存数"> </el-table-column>
        <el-table-column prop="customerName" label="变更当前库存数为"> </el-table-column>
      </el-table>
      <el-form ref="form" :model="form" class='mgt-18' label-width="80px">
        <el-form-item label="变更原因" prop="desc">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit('form')">提交审核</el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      form:{
        desc:"",
      },
      tableData: [],
      tableSelection: [],
    };
  },
  mounted(){
    console.log(this.$route.query.id) //这里必须有mounted函数执行否则会报错不知道啥原因
  },
  created() {
    console.log('query',this.$route.query.id,this.$route.matched)
  },
  methods: {
    query(checkId){
       this.$api.stock
        .getHouseStockCheckInfo(checkId)
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    submit(formName) {
      if (this.tableSelection.length != 1) {
        return this.$message.error("请选中一行数据");
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data={
            content:{},
            remark:this.form.desc
          }
          this.$api.store
            .addHouseStockCheck(data)
            .then((d) => {
              if (d.code == 200) {
                this.$refs.form.resetFields();
              } else {
                this.$message.error(d.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>